import { TranslocoModule, provideTranslocoScope } from '@jsverse/transloco';
import { Component, OnInit, computed, inject, input, output } from '@angular/core';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';

export interface NewCustomerFiltersValue {
  comune: string;
  provincia: string;
}

// Nel dialog arrivano anche comuni e province delle aziende trovate
export interface NewCustomerFiltersData {
  value: NewCustomerFiltersValue;
  comuni: string[];
  province: string[];
}

@Component({
  selector: 'ord-new-customer-filters',
  imports: [ReactiveFormsModule, MatButtonModule, MatDialogModule, MatFormFieldModule, MatSelectModule, TranslocoModule],
  providers: [provideTranslocoScope('orders')],
  templateUrl: './new-customer-filters.html',
  styleUrl: './new-customer-filters.scss',
})
export class NewCustomerFilters implements OnInit {
  readonly value = input<NewCustomerFiltersValue>({ comune: '', provincia: '' });
  readonly comuniOptions = input<string[]>([]);
  readonly provinceOptions = input<string[]>([]);
  readonly applied = output<NewCustomerFiltersValue>();
  readonly dialogRef = inject<MatDialogRef<NewCustomerFilters, NewCustomerFiltersValue>>(MatDialogRef, { optional: true });
  private readonly data = inject<NewCustomerFiltersData | null>(MAT_DIALOG_DATA, { optional: true });

  readonly comuni = computed(() => this.data?.comuni ?? this.comuniOptions());
  readonly province = computed(() => this.data?.province ?? this.provinceOptions());
  readonly form = inject(FormBuilder).nonNullable.group({ comune: [''], provincia: [''] });

  ngOnInit(): void {
    this.form.setValue(this.data?.value ?? this.value());
  }

  get hasValues(): boolean {
    const { comune, provincia } = this.form.getRawValue();
    return !!(comune || provincia);
  }

  clear(): void {
    this.form.reset();
  }

  apply(): void {
    const value = this.form.getRawValue();
    if (this.dialogRef) {
      this.dialogRef.close(value);
    } else {
      this.applied.emit(value);
    }
  }
}
